import {Injectable} from '@angular/core';
import {RegisterDataTableService} from '../../../core/services/register-data-table.service';
import {StorageService} from '../../../core/services/storage.service';
import {ITableColumn} from '../../../core/common/interfaces/table-column.interface';


@Injectable({
  providedIn: 'root'
})
export class IndexIasTableService extends RegisterDataTableService {


  constructor(
    storageService: StorageService
  ) {
    super(storageService);
  }


  override getColumns(): ITableColumn[] {
    return [
      {
        name: 'id',
        title: 'Id',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'indexIasName',
        title: 'Индекс ИАС Спорт',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'indexIasShortName',
        title: 'Условное обозначение',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'indexEntityId',
        title: 'Id индекса',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'organizationName',
        title: 'Учреждение',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'period',
        title: 'Тип оценки',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'year',
        title: 'Год',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'quarter',
        title: 'Квартал',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'value',
        title: 'Значение',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'status',
        title: 'Архив',
        useCustomTemplate: true,
        disabled: false,
        default: false,
      },
    ];
  }


}
